import {AppSettings} from "../../app-settings";
import {AuthorizationModel} from "../../authentication/models/authorization-model";
import {backboneModelProperties} from "../../decorators/backbone-properties";
import {UserHistoryItemModel} from "../../user-history/models/user-history-item";
import {AppEvents} from "../../app-events";

import {autoinject, Container} from "aurelia-dependency-injection";
import {prop} from "../../decorators/property";
import { ContainerHelper } from "../../shared/helpers/container-helper";

@backboneModelProperties({
    defaults: {
        Items: [],
        Page: 1,
        TimeSpan: "today",
        TotalPages: 1,
        TotalResults: 0,
        Loading: false
    },
    relations: [
        {
            key: "Items",
            relatedModel: UserHistoryItemModel,
            type: Backbone.Many,
        }
    ],
    urlRoot: AppSettings.ApiUrlPrefix + "userhistory",
})
export class UserHistoryModel extends AuthorizationModel {

    @prop() public TimeSpan: string;
    @prop() public Page: number;
    @prop() public Items: Backbone.Collection<UserHistoryItemModel>;
    @prop() public TotalResults: number;
    @prop() public ItemsPerPage: number;
    @prop() public TotalPages: number;
    @prop() public Loading: boolean;

    private appEvents: Backbone.Events;

    constructor(options?) {
        super(options );
        this.appEvents = ContainerHelper.Events;
        this.setupChangeListeners();
    }
    // horrible hack, since in the backbone.d.ts url is any, so we can't dynamically
    // calculate urls, since TS doesn't like it. which we need to get a page number with the get
    // so we do this whenever the properties in question are set before setting the property.
    public recalculateUrl(): void {
        let url = `${AppSettings.ApiUrlPrefix}userhistory`;
        if (this.TimeSpan !== "today") {
            url += `/${this.TimeSpan}/${this.Page}`;
        }
        this.url = url;
    }

    public setDefaults() {
        this.set(this.defaults, { silent: true });
    }

    public resetDataWithCurrentTimeSpan() {
        const oldTimeSpan = this.TimeSpan;
        this.Items.reset([]);
        this.setDefaults();
        this.set("TimeSpan", oldTimeSpan, { silent: true});
        this.recalculateUrl();
    }

    public load() {
        return new Promise((resolve, reject) => {
            this.Loading = true;
            const self = this;

            this.fetch({
                success: () => { self.Loading = false; },
                error: () => {
                    self.Loading = false;
                    self.TotalPages = 1;
                    self.resetDataWithCurrentTimeSpan();
                    self.appEvents.trigger(AppEvents.ErrorMessage, "Could not connect to server");
                }
            });
        });
    }

    private setupChangeListeners() {
        // when the page or timespan changes, re-fetch the model
        this.on("change:TimeSpan", () => {
            // set the page to 1 again, don't trigger no events though
            this.set("Page", 1, { silent: true});
            this.timeSpanOrPageChanged();
        });
        this.on("change:Page", this.timeSpanOrPageChanged);
        this.on("change:TotalResults", this.recalculateTotalPages);
        this.on("change:ItemsPerPage", this.recalculateTotalPages);
    }

    private timeSpanOrPageChanged() {
        this.recalculateUrl();
        this.load();
    }

    private recalculateTotalPages() {
        const totalPages = Math.ceil(this.TotalResults / this.ItemsPerPage);
        this.TotalPages = totalPages;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/user-history/models/user-history.ts